import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { createUseStyles } from 'react-jss'

import { Icon } from 'antd'
import { useDropzone } from 'react-dropzone'
import { dropZone as dropZoneStyles } from '../../../theme/shared-styles'

const useStyles = createUseStyles(theme => ({
  ...dropZoneStyles,
}))

export default function ReportUpload({ onUpload, manufacturer }) {
  const styles = useStyles()

  const onDrop = useCallback(
    acceptedFiles => {
      if (!onUpload) return

      onUpload(acceptedFiles)
    },
    [onUpload],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple: true,
    onDrop,
    disabled: false,
  })

  const dragAndDropMessage =
    'Drag and drop a PDF or click to select the file from your file browser'
  return (
    <>
      <div
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...getRootProps({
          className: classnames(
            styles.dropZone,
            isDragActive && styles.activeDropZone,
          ),
        })}
      >
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <input {...getInputProps()} />
        {isDragActive ? (
          <>
            <p>Drop the file here ...</p>
            <Icon type="file-add" theme="filled" />
          </>
        ) : (
          <>
            <p>{dragAndDropMessage}</p>
            <Icon type="file-zip" />
          </>
        )}
      </div>
    </>
  )
}

ReportUpload.defaultProps = {
  onUpload: () => {},
  manufacturer: '',
}

ReportUpload.propTypes = {
  onUpload: PropTypes.func,
  manufacturer: PropTypes.string,
}
